import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useNativePlatform } from "@/hooks/useNativePlatform";
import { isMarketingPath, NATIVE_GUEST_HOME } from "@/lib/native/nativeRoutes";
import NativeAppSkeleton from "./NativeAppSkeleton";

/**
 * In the native app only, marketing landing pages redirect to dashboard or auth.
 */
const NativeMarketingRedirect = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const { user, isLoading } = useAuth();
  const { isNative } = useNativePlatform();

  if (!isNative || !isMarketingPath(location.pathname)) {
    return <div className="native-page-outlet">{children}</div>;
  }

  if (isLoading) {
    return <NativeAppSkeleton />;
  }

  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Navigate to={NATIVE_GUEST_HOME} replace />;
};

export default NativeMarketingRedirect;
